var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { id: "verified-form" },
      on: {
        submit: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
        },
      },
    },
    [
      _c("div", { staticClass: "form-page" }, [
        _c(
          "div",
          { staticClass: "container-main" },
          [
            _c(
              "b-row",
              {
                staticClass: "w-100 bg justify-content-center",
                attrs: { "no-gutters": "" },
              },
              [
                _c(
                  "b-col",
                  {
                    staticStyle: { "text-align": "center" },
                    attrs: { cols: "11", sm: "7" },
                  },
                  [
                    _c("h1", { staticClass: "main-title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("account.verification.accountVerified")
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "description",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t(
                            "account.verification.accountVerifiedDescription"
                          )
                        ),
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass: "w-100 justify-content-center",
                attrs: { "no-gutters": "" },
              },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "text-center img-checked img-verified",
                    attrs: { lg: "4", md: "3" },
                  },
                  [
                    _c("img", {
                      staticClass: "img-fluid",
                      attrs: {
                        width: "200px",
                        src: require("@Shared/@Assets/img/app-flow/ico-condo.svg"),
                        alt: "",
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass: "w-100 justify-content-center",
                attrs: { "no-gutters": "" },
              },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "text-center",
                    attrs: { cols: "11", sm: "6", lg: "6" },
                  },
                  [
                    _c("p", { staticClass: "description" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("account.verification.youCanLogin")) +
                          "\n          "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "app-flow-buttons mt-4" },
              [
                _c(
                  "b-row",
                  { staticClass: "w-100 justify-content-center" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "forward", attrs: { md: "6", sm: "5" } },
                      [
                        _c("input", {
                          staticClass: "go-to-portal btn-primary btn",
                          attrs: { type: "submit" },
                          domProps: {
                            value: _vm.$t(
                              "account.verification.loginToContinue"
                            ),
                          },
                          on: { click: _vm.goToLogin },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }